import { el, setChildren } from "redom"
import { fillInUserListModal } from "../components/record-content.js"
import { Modal } from "bootstrap"
import { LikeService } from "../services/like-service.js"
export const getSingularOrPlural = (count: number, word: string) => count + " " + word + (count > 1 ? "s" : "")

const renderLikeIcon = (isLiked: boolean) => {
    const btn = document.getElementById("likeIcon")
    if (btn) {
        btn.className = isLiked ? "fas fa-heart" : "far fa-heart"
        // btn.style.color = isLiked ? "#eb2940" : "#555555"
    }
}

const renderLikeCount = (count: number, recordId: string) => {
    const linkLike: HTMLDivElement = count > 0 ? el("div", { onclick: () => showLikedList(recordId) }, el("u.clickable", { textContent: getSingularOrPlural(count, "like") }))
        : el("div", { textContent: count + " likes" })
    const likesContent = document.getElementById("likesContent")
    if (likesContent) setChildren(likesContent, [linkLike])
}

const showLikedList = (recordId: string) => {
    const likesModal = Modal.getOrCreateInstance("#likesModal");
    likesModal.show();
    return LikeService.getLikedUsers(recordId)
        .then(result => fillInUserListModal(result.users, "Like", likesModal)
        ).catch(() => alert("Could not load likes"))
}

export const LIKE = {
    _isLiked: false,
    _count: 0,

    init: function (recordId: string, isLiked: boolean, count: number, isMe: boolean) {
        this._isLiked = isLiked
        this._count = count
        if (isMe) { renderLikeIcon(isLiked) }
        renderLikeCount(count, recordId)
    },

    toggle: function (userId: string, recordId: string) {
        this._isLiked = !(this._isLiked)
        this.update(userId, recordId)
        renderLikeIcon(this._isLiked)
        renderLikeCount(this._count, recordId)
    },

    update: function (userId: string, recordId: string) {
        this._count += this._isLiked ? 1 : -1
        return this._isLiked ? LikeService.like(userId, recordId) : LikeService.unlike(userId, recordId)
    }
}